import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import styles from '../../../../../ApplicationMaintenance.module.scss';

//options : AppData[]
// handleChange : function()
const AppDataSelect = ({
	options,
	handleChange,
	selected,
	validationErrors = [],
}) => {
	return (
		<>
			<FormControl sx={{ minWidth: 120 }}>
				<InputLabel id='AppDataSelectDropdown-label'>
					App Data
				</InputLabel>
				<Select
					labelId='AppDataSelectDropdown-label'
					id='AppDataSelectDropdown'
					value={selected?.id ?? ''}
					onChange={handleChange}
					error={validationErrors.length > 0}
					label='App Data'
				>
					{options.map(option => {
						return (
							<MenuItem key={option.id} value={option.id}>
								{option.fieldValue}
							</MenuItem>
						);
					})}
				</Select>
				<div>
					<ul>
						{validationErrors.map(err => (
							<li className={styles.error}>{err.message}</li>
						))}
					</ul>
				</div>
			</FormControl>
		</>
	);
};

export default AppDataSelect;
